import I18n from 'i18n-js';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {
  CASH,
  CASH_BY_RECIPIENT,
  CASH_BY_SENDER,
  FIELD_PLACEHOLDER,
  POSTPAID_BILLING_TYPE,
  PAYMENT_TYPE_GRABPAY,
  WEB_UNSUPPORTED_PAYMENT_TYPES,
} from 'constants/booking-constants';
import formatCurrency from 'common/utils/format-currency.js';

export const paymentMethodForDisplayV2 = ({
  paymentMethod = {},
  paymentMethodMap,
  countryCode = '',
}) => {
  const { id, paidBy } = paymentMethod;

  // cash case
  switch (paidBy) {
    case CASH_BY_SENDER:
      return I18n.t('booking.paymentMethod.cashBySender');
    case CASH_BY_RECIPIENT:
      return I18n.t('booking.paymentMethod.cashByRecipient');
  }

  const pmToDisplay = _get(paymentMethodMap, id);
  if (pmToDisplay) {
    const type = pmToDisplay.type;
    const ref = pmToDisplay.name || pmToDisplay.refNumber;

    if (type === POSTPAID_BILLING_TYPE) {
      return I18n.t(FIELD_PLACEHOLDER.CORP_BILLING);
    }

    if (type === PAYMENT_TYPE_GRABPAY) {
      if (countryCode === 'ID') {
        return I18n.t('booking.paymentMethod.ovoCash');
      }
      return I18n.t('booking.paymentMethod.grabPay');
    }

    if (type && ref) {
      return `${type} ${ref}`;
    }
    if (type || ref) {
      return type || ref;
    }
  }

  return '--';
};

// showCashlessPaymentDetail: when set to false, do not display payment details such as credit card last 4 digits
export const paymentMethodForDisplay = (
  paymentMethod,
  showCashlessPaymentDetail = true,
  countryCode = '',
) => {
  const { type: paymentType, name: paymentName, paidBy } = paymentMethod;

  if (paymentType === POSTPAID_BILLING_TYPE) {
    return I18n.t(FIELD_PLACEHOLDER.CORP_BILLING);
  }

  if (paymentType === CASH || paymentName === CASH) {
    if (paidBy === CASH_BY_SENDER) {
      return I18n.t('booking.paymentMethod.cashBySender');
    }

    if (paidBy === CASH_BY_RECIPIENT) {
      return I18n.t('booking.paymentMethod.cashByRecipient');
    }

    return `${paymentType}`;
  }

  if (paymentType === PAYMENT_TYPE_GRABPAY) {
    if (countryCode === 'ID') {
      return I18n.t('booking.paymentMethod.ovoCash');
    }
    return I18n.t('booking.paymentMethod.grabPay');
  }

  // cashless payments (credit cards etc)
  const type = paymentType || '--';
  const ref = paymentName || paymentMethod.refNumber || '--';
  return showCashlessPaymentDetail ? `${type} ${ref}` : type;
};

export const filterWebUnsupportedPayments = payments =>
  payments.filter(p => !WEB_UNSUPPORTED_PAYMENT_TYPES.includes(p.type));

export const paymentMethodsFromActionPayload = paymentActionPayload => {
  if (
    _isEmpty(paymentActionPayload) ||
    _isEmpty(_get(paymentActionPayload, 'result'))
  ) {
    return { result: [] };
  }

  return {
    result: filterWebUnsupportedPayments(
      _get(paymentActionPayload, 'result', []),
    ),
  };
};

export const getPostpaidPaymentMethod = paymentMethods => {
  if (_isEmpty(paymentMethods)) return undefined;
  return paymentMethods.find(payment => payment.type === POSTPAID_BILLING_TYPE);
};

export const getGrabPayPaymentMethod = paymentMethods => {
  if (_isEmpty(paymentMethods)) return undefined;
  return paymentMethods.find(payment => payment.type === PAYMENT_TYPE_GRABPAY);
};

export const getGrabPayBalanceDisplay = grabPayPaymentMethod => {
  if (
    grabPayPaymentMethod &&
    _get(grabPayPaymentMethod, 'payload.BalanceErrorCode') === 0
  ) {
    return formatCurrency({
      code: _get(grabPayPaymentMethod, 'payload.Currency'),
      amount: _get(grabPayPaymentMethod, 'payload.Balance'),
    });
  }
  return '';
};

export const getCreditCardPaymentMethods = paymentMethods => {
  if (_isEmpty(paymentMethods) || !paymentMethods) return [];
  return paymentMethods.filter(
    p => p.type !== POSTPAID_BILLING_TYPE && p.type !== PAYMENT_TYPE_GRABPAY,
  );
};

export default {};
